
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({

  campoOnDrag: {
    border: 'dashed 2px #cdcdcd',
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
    alignItems: 'center',
  },
  campoOnDragAtivo: {
    border: 'dashed 2px #cdcdcd',
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
    alignItems: 'center',
    backgroundColor: '#A8CFFF',
  },
  dropIcon: {
    height: '65px',
    width: '65px',
    color: '#c5d8ff',
  },
  mainButon: {
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    border: 'solid 1px #97c1ff',
    color: '#044ada',
    marginTop: 15,
    marginBottom: 10,
    padding: '10px 20px',
    cursor: 'pointer',
    backgroundColor: 'white',
  },
  titulo: {
    fontSize: 24,
    fontWeight: 500,
    color: 'black',
    opacity: 0.5,
  },
  fileLabels: {
    fontFamily: 'IBM PLex Sans',
    color: '#5e6784',
    fontWeight: 500,
    fontSize: 16,
  },
  campoFile: {
    backgroundColor: 'white',
    padding: 10,
    borderRadius: 4,
    border: 'solid 1px #dfdfe6',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  nomeFile: {
    fontSize: 16,
    fontFamily: 'IBM Plex Sans',
    color: '#061243',
    margin: 0,
    padding: 0,
    paddingTop: 5,
  },
  nomeFileSpan: {
    fontSize: 12,
    fontFamily: 'IBM Plex Sans',
    color: '#5e6784',
    margin: 0,
    padding: 0,
    position: 'relative',
    top: -5,
  },
  tamanhoFile: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    color: '#5e6784',
    alignSelf: 'center',
    height: '100%',
    verticalAlign: 'center',
  },
});

export default useStyles;
